import AXIOS from 'axios'
import store from '../store.js'
import util from './util'
import urls from './urls'
import QS from 'qs'

let HTTP = function() {
    this.POST = (urlKey, params, options = {}) => {
        return new Promise((resolve, reject) => {
            // console.log(store);
            //处理参数
            if (!params.token) params.token = store.state.userinfo.token ? store.state.userinfo.token : '';
            if (!params.userId) params.userId = store.state.userinfo.userId ? store.state.userinfo.userId : '';
            // 校验参数（不可传undefined和null），过滤空格
            for (let index in params) {
                if (util.isBlank(params[index])) {
                    params[index] = '';
                } else if (typeof params[index] === 'string') {
                    params[index] = params[index].replace(/(^[\s\n\t]+|[\s\n\t]+$)/g, "");
                }
            }

            //处理请求链接
            var url = "";
            if (options.urlType === 'wallService') {
                url = urls.getUrl_Wallet_Service(urlKey, options.suffix)
            } else if (options.urlType === 'newmenu') {
                url = urls.getUrl_newmenu(urlKey, options.suffix)
            } else if (options.urlType === 'report') {
                url = urls.getUrl_report(urlKey, options.suffix)
            } else {
                url = urls.getUrl(urlKey, options.suffix)
            }



            //处理请求头
            let headers = {
                'content-type': options.urlType === 'report' ? 'application/json;charset=UTF-8' : 'application/x-www-form-urlencoded;charset=UTF-8',
                'authToken': params.token,
                'authUserid': params.userId
            };

            // let demo = '{"eventId":"NewUserInvitation_1001","attributes":{"activity_id":"DISID5d2ed3a4bc49e891842b1646","activity_name":"1分钱冬菇肉饼饭","activity_type":"发放内部优惠券"},"token":"eyJhbGciOiJIUzI1NiJ9.eyJqdGkiOiJVNWQxMzg4OGE3ZWVhNWRkMzEyYmEwYWMxIiwic3ViIjoi5bCP6IOW57G95LiN5oOz5YqoICoiLCJpc3MiOiLnnJ_lip_lpKvlip_lpKvkvJoiLCJpYXQiOjE1NzA3NzY0MTksImV4cCI6MTU3MDgxMjQxOX0.lh_mvCSW-dpUmaDDgcoEc4edKSr361iJjg3urVEhNEU","userId":"U5d13888a7eea5dd312ba0ac1"}'
            // let demoJson = JSON.parse(demo);
            // if (options.urlType == 'report') {

            //     headers.authToken = demoJson.token;
            //     headers.authUserid = demoJson.userId;
            // }
            //处理请求方式
            let method = options.method ? options.method : 'post'

            //处理请求对象
            let requestParams = {
                url,
                method,
                headers,
                data: options.urlType === 'report' ? params : QS.stringify(params)
            };
            // console.log("比较", demoJson, params);
            console.log('吊起请求方法', urlKey, params, options);
            console.log('开始请求', requestParams);
            let task = AXIOS.request(requestParams)
            if (options.urlType === 'report') return;

            task.then((res) => {
                    console.log('请求成功', res);

                    if (res.status !== 200) {
                        //网络框架报错
                        reject(res.data)
                    } else if (res.data.code !== 200) {
                        //服务器报错
                        reject(res.data)
                    } else {
                        //正常返回
                        resolve(res.data)
                    }
                })
                .catch((err) => {
                    console.log('请求失败', err);
                    reject({ message: "服务器开了小差,请稍后" })
                })
        })

    };
};

HTTP.getInstance = (function() {
    var instance = null

    return function() {
        if (!instance) {
            instance = new HTTP()
        }
        return instance
    }
})()

export default HTTP.getInstance()